module.exports = __webpack_public_path__ + "media/container_component/bg-ellipsis-d07f785f.svg";